(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.snsInit === '1') return;
    root.dataset.snsInit = '1';

    var track = root.querySelector('[data-sns-track]');
    var slides = root.querySelectorAll('[data-sns-slide]');
    var dots = root.querySelectorAll('[data-sns-dot]');
    var prev = root.querySelector('[data-sns-prev]');
    var next = root.querySelector('[data-sns-next]');
    if (!track || slides.length === 0) return;

    var index = 0;

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      for (var k = 0; k < dots.length; k++) {
        if (k === index) {
          dots[k].classList.add('active');
          dots[k].setAttribute('aria-current', 'true');
        } else {
          dots[k].classList.remove('active');
          dots[k].setAttribute('aria-current', 'false');
        }
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    for (var k = 0; k < dots.length; k++) {
      (function (i) {
        dots[i].addEventListener('click', function () { go(i); });
      })(k);
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(index - 1); }
      if (e.key === 'ArrowRight') { go(index + 1); }
    });

    var startX = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); }
      startX = null;
    });

    go(0);
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-sns-carousel]');
    for (var i = 0; i < nodes.length; i++) initCarousel(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sns-carousel]');
    if (el) { el.dataset.snsInit = ''; initCarousel(el); }
  });
})();
